import axios from 'axios'
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL, 
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
        let sso = sessionStorage.getItem("sso") || '{}'
        let sso_details = JSON.parse(sso);
    if (sso_details) {
        if (config.headers){
            config.headers.Authorization = `Bearer ${sso_details.idToken}`;
        } 
    }
    return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle response errors here
    if (error.response.status === 401){
        sessionStorage.removeItem("sso");
        sessionStorage.removeItem('hasInfoDialogShown');
        window.location.reload();
        return Promise.reject(error)
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;;